<template>
    <div class="attachment" style="overflow-y: auto;overflow-x: hidden;max-height: 500px;">
        <div class="page">
            <button @click="prePage">上一页</button>
            <span v-text="(selectedIndex+1) + '/' + fj.length"></span>
            <button @click="nextPage">下一页</button>
        </div>
        <div class="img-box" v-for="(data,index) in fj" :key="data.id" v-show="selectedIndex===index">
            <div v-if="isImg">
                <p style="margin-top: 100px;text-align: center;position: absolute;z-index: 50;width: 600px">正在加载中...</p>
                <a href="javascript:void(0);" style="display: inline-block;width: 100%;">
                    <img :src="getShowFjUrl(null,data.storedFilePath,null,'PATH') || getShowFjUrl(domain,data.id,null)" class="img">
                </a>
            </div>
            <a class="center_href" :href="getShowFjUrl(null,data.storedFilePath,null,'PATH') || getShowFjUrl(domain,data.id,null)" target="_blank" v-else>
                该文件暂不支持预览，点击下载
            </a>
        </div>
    </div>
</template>

<script>
    import {getShowFjUrl, isAssetTypeAnImage} from "@/core/common"

    export default {
        name: "Attachment",
        data() {
            return {
                selectedIndex: 0,
            }
        },
        props: ["fj"],
        mounted() {
        },
        methods: {
            getShowFjUrl,
            isAssetTypeAnImage,
            prePage() {
                this.selectedIndex = this.selectedIndex === 0 ? 0 : this.selectedIndex - 1;
            },
            nextPage() {
                this.selectedIndex = this.selectedIndex === this.fj.length - 1 ? this.fj.length - 1 : this.selectedIndex + 1;
            }
        },
        computed: {
            fjName() {
                if (this.fj.length > 0) {
                    return this.fj[this.selectedIndex].name || this.fj[this.selectedIndex].readableFileName;
                }
                return null;
            },
            isImg() {
                if (this.fj.length > 0) {
                    return this.isAssetTypeAnImage(this.fj[this.selectedIndex].storedFilePath);
                }
                return false;
            }
        },
    }
</script>

<style scoped>
    .page {
        margin-top: 10px !important;
        margin-bottom: 10px !important;
        text-align: center;
    }

    .page span {
        font-size: 18px;
        padding: 0 10px;
    }

    .page button {
        color: #fff; /*字体颜色*/
        background-color: #4293f4; /*按钮背景颜色*/
        border-radius: 3px; /*让按钮变得圆滑一点*/
        border-width: 0; /*消去按钮丑的边框*/
        outline: none; /*取消轮廓*/
        font-size: 17px; /*设置字体大小*/
        text-align: center; /*字体居中*/
        cursor: pointer; /*设置鼠标箭头手势*/
        margin: 0;
    }

    .attachment > div {
        margin: 0 auto;
    }

    .attachment .img-box {
        width: 680px;
    }

    .center_href {
        margin-top: 100px;
        text-align: center;
        display: block;
        z-index: 50;
    }

    .img {
        margin-bottom: 30px;
        position: relative;
        z-index: 100;
        width: 100%
    }
</style>
